<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/products" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Produkt hinzufügen</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newProductForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-10 form-div">
                <b-form-group id="fieldset-horizontal">
                  <vue-dropzone
                    name="productPictures"
                    ref="uploadProductImages"
                    id="example-input-0 dropzone"
                    :useCustomSlot="true"
                    :options="dropzoneOptions"
                    @vdropzone-file-added="(file) => uploadFile(file)"
                    @vdropzone-removed-file="handleRemoveImage"
                    aria-describedby="input-0-live-feedback"
                  >
                    <div class="dropzone dropzone-default" id="kt_dropzone_1">
                      <div class="dropzone-msg dz-message needsclick">
                        <h4>Bitte laden sie Produktbilder hoch</h4>
                        <h5>Dateien hierhin ziehen oder klicken zum Upload</h5>
                        <p>
                          Erlaubte Formate: JPEG, PNG
                          <br />Maximale Upload-Größe: 1MB
                        </p>
                      </div>
                    </div>
                  </vue-dropzone>
                </b-form-group>
                <!-- <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Producer is required.',
                    }"
                  >
                    <v-autocomplete
                      v-model="form.producer"
                      :error-messages="errors[0]"
                      :items="providers"
                      :value="providers.id"
                      outlined
                      item-text="brand_name"
                      item-value="id"
                      label="Händler wählen"
                      @change="getGeneralSettings($event)"
                    ></v-autocomplete>
                  </ValidationProvider>
                </b-form-group> -->
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Produktname ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.productName"
                          :error-messages="errors[0]"
                          label="Produktname"
                          outlined
                          @input="getSlug(2, form.productName)"
                        ></v-text-field> 
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Produktkategorie ist erforderlich',
                        }"
                      >
                        <v-select
                          :items="categories"
                          v-model="form.productCategory"
                          :error-messages="errors[0]"
                          item-text="category_name"
                          item-value="id"
                          label="Produktkategorie"
                          outlined
                        />
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <h6>Produktbeschreibung</h6>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Produktbeschreibung ist erforderlich',
                        }"
                      >
                        <!-- <vue-editor
                          placeholder="Produktbeschreibung"
                          :class="errors[0] ? 'error-outline' : ''"
                          v-model="form.productDescription"
                        ></vue-editor> -->
                        <ckeditor
                          v-model="form.productDescription"
                          :config="editorConfig"
                          @blur="getEditorData(form.productDescription)"
                        ></ckeditor>
                        <span class="text-danger"
                          ><b>{{ errors[0] }}</b></span
                        >
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>

                <div class="row">
                  <div class="col-md-6">
                    <!--<b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="product price"
                        rules="required|min_value:1"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Product price is required.',
                        }"
                      >
                        <v-text-field
                          type="number"
                          step="0.01"
                          autocomplete="new-password"
                          v-model="form.productPrice"
                          :error-messages="errors[0]"
                          label="Product Price"
                          outlined
                        ></v-text-field>
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>-->
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Einheit ist erforderlich',
                        }"
                      >
                        <v-select
                          :items="unitsList"
                          v-model="form.productUnit"
                          :error-messages="errors[0]"
                          item-text="unit"
                          item-value="id"
                          label="Einheit"
                          outlined
                        />
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <v-select
                        :items="badges"
                        v-model="form.productBadge"
                        item-text="name"
                        item-value="id"
                        label="Abzeichen"
                        outlined
                        clearable
                      />
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <!-- product feature -->
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                        <v-combobox
                          v-model="form.productFeatures"
                          :items="allProductFeatures"
                          label="Produkteigentschaften"
                          item-text="feature"
                          item-value="id"
                          multiple
                          outlined
                        ></v-combobox>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="Alters-Limit"
                        rules="min_value:0"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Das Alters-Limit muss 0 oder größer sein',
                        }"
                      >
                        <v-text-field
                          type="number"
                          autocomplete="new-password"
                          v-model="form.ageLimit"
                          :error-messages="errors[0]"
                          label="Alters-Limit"
                          min="0"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <!-- <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Lieferbedingungen sind erforderlich',
                        }"
                      >
                        <v-combobox
                          v-model="form.deliveryOptions"
                          :items="allDeliveryOptions"
                          :error-messages="errors[0]"
                          label="Lieferbedingungen"
                          item-text="lable"
                          item-value="id"
                          multiple
                          outlined
                        ></v-combobox>
                      </ValidationProvider>
                    </b-form-group>
                  </div> -->
                </div>
                <v-divider></v-divider>
                <!-- end product feature -->

                
                <!-- Product Prices -->
                <div
                  class="row"
                  v-for="(pr, i) in form.productPrices"
                  :key="'P' + i"
                >
                  <div class="col-md-3">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required|maxQuantity"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Menge ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="pr.quantity"
                          :error-messages="errors[0]"
                          label="Menge (laut Einheit)"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Lagerstand ist erforderlich',
                        }"
                      >
                        <v-text-field
                          type="number"
                          autocomplete="new-password"
                          v-model="pr.stock"
                          :error-messages="errors[0]"
                          label="Lagerstand"
                          min="0"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="product price"
                        rules="required|priceInput"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Produktpreis (€) ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="pr.price"
                          :error-messages="errors[0]"
                          label="Produktpreis (€)"
                          outlined
                        ></v-text-field>
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div
                    v-if="i > 0"
                    class="col-md-1 plus-circle-btn removeService"
                  >
                    <a @click="removePrice(i)"
                      ><b-icon icon="x-circle"></b-icon
                    ></a>
                  </div>
                  <div class="col-md-1 plus-circle-btn" v-else>
                    <a @click="addPrice"
                      ><b-icon icon="plus-circle"></b-icon
                    ></a>
                  </div>
                </div>
                <v-divider></v-divider>
                <!-- end Product Prices -->
                <!-- Product Information -->
                <div
                  class="row"
                  v-for="(info, i) in form.productInformations"
                  :key="i"
                >
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <v-autocomplete
                        v-model="info.infoId"
                        :items="informations"
                        outlined
                        item-text="lable"
                        item-value="id"
                        label="Produktinformation"
                        clearable
                      ></v-autocomplete>
                    </b-form-group>
                  </div>
                  <div class="col-md-5">
                    <b-form-group id="fieldset-horizontal">
                      <v-select
                        :items="infoValues"
                        v-model="info.value"
                        item-text="lable"
                        item-value="value"
                        label="Wert (Ja/Nein)"
                        outlined
                        clearable
                      />
                    </b-form-group>
                  </div>
                  <div
                    v-if="i > 0"
                    class="col-md-1 plus-circle-btn removeService"
                  >
                    <a @click="removeInformation(i)"
                      ><b-icon icon="x-circle"></b-icon
                    ></a>
                  </div>
                  <div class="col-md-1 plus-circle-btn" v-else>
                    <a @click="addInformation"
                      ><b-icon icon="plus-circle"></b-icon
                    ></a>
                  </div>
                </div>
                <v-divider></v-divider>
                
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required|priceInput"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der MWSt. (%) ist erforderlich',
                          min_value: 'Die MWSt. (%) muss 0 oder größer sein',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.vatPercent"
                          :error-messages="errors[0]"
                          label="MWSt. (%)"
                          outlined
                        ></v-text-field>
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <!-- Meta description added -->
                
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required|max160"
                        v-slot="{ errors }"
                      >
                        <v-textarea
                          v-model="form.productMetaDescription"
                          label="Produkt Meta Beschreibung für SEO (max. 160 Zeichen, Standard: Produkt Beschreibungstext)"
                          :error-messages="errors[0]"
                          outlined
                          @blur="restorePopUp(e=1)"
                        ></v-textarea>
                        <span class="text-danger" v-if="form.productMetaDescription.length > 160">{{ errors[0] }}</span>
                      </ValidationProvider>    
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required|max50"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="form.productMetaTitle"
                          :error-messages="errors[0]"
                          label="Produkt Meta Name für SEO (max. 50 Zeichen, Standard: Produkt Name)"
                          outlined
                          @blur="restorePopUp(e=2)"
                        ></v-text-field>
                        <span class="text-danger" v-if="form.productMetaTitle.length > 50">{{ errors[0] }}</span>
                      </ValidationProvider>  
                    </b-form-group>
                  </div>
                  <div class="col-md-6">

                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="form.productCanonicalLink"
                          :error-messages="errors[0]"
                          label="Produkt Canonical Link für SEO (Standard: Produkt URL)"
                          outlined
                          @blur="restorePopUp(e=3)"
                        ></v-text-field>
                      </ValidationProvider>    
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                      >
                      <v-select
                          :items="robotValues"
                          v-model="form.productMetaRobot"
                          item-text="lable"
                          item-value="value"
                          :error-messages="errors[0]"
                          label="Produkt Meta Robots Einstellung für SEO (Standard: index, follow)"
                          outlined
                        />
                      </ValidationProvider>  
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>                

                <div class="fo-row-btn text-right">
                  <v-btn class="submit-btn-fill-outline" @click="goToBack">
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="button"
                    :disabled="isDraftDisabled"
                    ref="kt_form_submit_btn"
                    @click="saveDraft()"
                    class="submit-btn-fill-outline"
                  >
                    {{ draftText }}
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
        <v-dialog v-model="statusDialog" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              Bitte bestätigen
            </v-card-title>
            <v-card-text>
              <span>Möchten Sie den Wert wiederherstellen?</span>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                :disabled="disabledCancel"
                class="no-button"
                @click="hideModal"
              >
                Nein
              </v-btn>
              <v-btn
                type="submit"
                @click="restore()"
                ref="kt_form_submit_btn"
                class="yes-button"
                :loading="yesActionLoading"
              >
                Ja
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="statusDelar" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              Bitte bestätigen
            </v-card-title>
            <v-card-text>
              <span>Wenn Sie den Händler nicht hinzufügen, fügen Sie bitte zuerst den Händler hinzu!</span>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                class="no-button"
                @click="hideModal"
              >
              OK
              </v-btn>
             
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <notifications group="products" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import moment from "moment";
import config from "@/config/app";
import adminAPI from "@/api/admin";
import providerAPI from "@/api/provider";
import CKEditor from "ckeditor4-vue";
import metarobots from "@/config/constant";

Vue.use(CKEditor);
// import { VueEditor, Quill } from "vue2-editor";

Vue.use(Notifications);

import { extend } from "vee-validate";

extend("priceInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^[0-9.,]+$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

extend("max160", {
  message: (field) => "Produkt Meta Beschreibung: maximal 160 Zeichen",
  validate: (value) => {
    var regx = /^.{0,160}$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

extend("max50", {
  message: (field) => "Produkt Meta Name: maximal 50 Zeichen",
  validate: (value) => {
    var regx = /^.{0,50}$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

extend("maxQuantity", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^[1-9000.,]+$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

export default {
  name: "AddProduct",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      const getProducer = this.getProducers()
      const categoryPromise = this.getCategories();
      const paymentOptionsPromise = this.getPaymentOptions();
      const infoPromise = this.getInformation();
      // const ProducerPromise = this.getActiveProducers();
      const badgePromise = this.getActiveBadges();
      this.infoValues = this.getInfoValues();
      this.robotValues = metarobots; 
      const productFeaturesPromise = this.getProductFeatures();
      // const productCertificatePromise = this.getProductCertificates();
      // const deliveryOptionsPromise = this.getDeliveryOptions();
      const unitsPromise = this.getProductUnits();
      Promise.all([
        getProducer,
        categoryPromise,
        paymentOptionsPromise,
        infoPromise,
        // ProducerPromise,
        badgePromise,
        productFeaturesPromise,
        // productCertificatePromise,
        // deliveryOptionsPromise,
        unitsPromise,
      ]).then(() => {});
    }
    this.form.productMetaRobot = this.robotValues[0].value
  },
  components: {
    vueDropzone: vue2Dropzone,
    // VueEditor,
  },
  data() {
    return {
      dropzoneOptions: {
        url: config.API_URL + "add-product",
        thumbnailWidth: 150,
        maxFilesize: 1,
        maxFiles: 10,
        addRemoveLinks: true,
        autoProcessQueue: false,
        timeout: 20000000,
        acceptedFiles: ".jpeg, .jpg, .png",
        uploadMultiple: true,
        headers: { Authorization: `Bearer ${JwtService.getToken()}` },
      },
      editorConfig: {
        language: 'de',scayt_sLang : 'de_DE'
      },
      submitText: "Abschicken",
      draftText: "Entwurf speichern",
      formError: false,
      userId: null,
      formData: [],
      categories: [],
      infoValues: [],
      robotValues: [],
      robot_value: '',
      badges: [],
      paymentOptions: [],
      allProductFeatures: [],
      allProductCertificates: [],
      // allDeliveryOptions: [],
      informations: [],
      statesList: [],
      unitsList: [],
      providers: [],
      btnDisable: false,
      btnDraftDisable: false,
      submitStatus: null,
      form: {
        productImages: "",
        productName: "",
        productMetaDescription:"",
        productMetaTitle: "",
        productCanonicalLink: "",
        productDescription: "",
        productCategory: "",
        productPrice: "",
        ageLimit: 0,
        vatPercent: 0,
        productBadge: "",
        productUnit: "",
        productPayOption: "",
        productFeatures: [],
        productCertificates: [],
        // deliveryOptions: [],
        producer: "",
        productInformations: [
          {
            infoId: "",
            value: "",
          },
        ],
        // stateInformations: [
        //   {
        //     stateId: "",
        //     postalCode: "",
        //   },
        // ],
        productPrices: [
          {
            quantity: 1,
            price: "",
            stock: ""
          },
        ],
      },
      brand_name:'',
      brand_name_slug:'',
      product_name_slug:'',
      statusDialog: false,
      restoreField:null,
      is_admin_dealer:1,
      providerID:'',
      statusDelar:false,
    };
  },
  methods: {
    getInformation() {
      adminAPI
        .getProductInfo()
        .then((response) => {
          if (response.status == "success") {
            this.informations = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },

    getPaymentOptions() {
      adminAPI
        .getPaymentOptions()
        .then((response) => {
          if (response.status == "success") {
            this.paymentOptions = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    getProviderData() {
      adminAPI
        .editProducer({ id: this.$route.params.id })
        .then((response) => {
          if (response.status == "success") {
              if (response.data.producer_detail.categories.length) {
                  response.data.producer_detail.categories.forEach((item) => {
                    if (item.category_detail) {
                      this.categories.push({
                        category_name: item.category_detail.category_name,
                        id: item.category_id,
                      });
                    }
                  });
              }
        
            }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    getProductFeatures() {
      adminAPI
        .getProductFeatures()
        .then((response) => {
          if (response.status == "success") {
            this.allProductFeatures = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },

    getProductUnits() {
      adminAPI
        .getProductUnits()
        .then((response) => {
          if (response.status == "success") {
            this.unitsList = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },

    // getDeliveryOptions() {
    //   adminAPI
    //     .getDeliveryOptions()
    //     .then((response) => {
    //       if (response.status == "success") {
    //         this.allDeliveryOptions = response.data;
    //       } else {
    //         this.$notify({
    //           group: "products",
    //           type: "error",
    //           position: "bottom right",
    //           text: response.msg,
    //           duration: 3000,
    //         });
    //       }
    //     })
    //     .catch((err) => {
    //       this.$notify({
    //         group: "products",
    //         type: "error",
    //         position: "bottom right",
    //         text: err,
    //         duration: 3000,
    //       });
    //     });
    // },

    getActiveBadges() {
      adminAPI
        .getActiveBadges()
        .then((response) => {
          if (response.status == "success") {
            this.badges = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },

    getInfoValues() {
      return [
        {
          lable: "Ja",
          value: "Ja",
        },
        {
          lable: "Nein",
          value: "Nein",
        },
      ];
    },
    addInformation() {
      this.form.productInformations.push({
        infoId: "",
        value: "",
      });
    },
    removeInformation(i) {
      this.form.productInformations.splice(i, 1);
    },

    addPrice() {
      this.form.productPrices.push({
        quantity: "",
        price: "",
        stock: ""
      });
    },
    removePrice(i) {
      this.form.productPrices.splice(i, 1);
    },

    goToBack() {
      this.$router.push({ name: "products" });
    },
    getCategories() {
      adminAPI
        .activeCategory()
        .then((response) => {
          if (response.status == "success") {
            this.categories = response.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    getActiveProducers() {
      axios
        .get("active-producers")
        .then((response) => {
          var responseJson = response.data;
          if (responseJson.status == "success") {
            this.providers = responseJson.data;
          } else {
            this.$notify({
              group: "products",
              type: "error",
              position: "bottom right",
              text: responseJson.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    uploadFile(file) {
      setTimeout(() => {
        this.form.productImages = this.$refs.uploadProductImages.getQueuedFiles();
      }, 1000);
    },
    handleRemoveImage() {
      this.form.productImages = this.$refs.uploadProductImages.getQueuedFiles();
    },

    getGeneralSettings(provider_id) {
      adminAPI
        .activeProducerCategory(provider_id)
        .then((response) => {
         
          if (response.status == "success") {
            this.categories = []
            response.data.forEach((item) => {             
              if (item.category_detail) {
                this.categories.push({category_name: item.category_detail.category_name,
                        id: item.category_id});
              }
            });
          } else {
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });

      adminAPI
        .getGeneralSettings({ id: provider_id })
        .then((response) => {
          if (response.status == "success") {
              
              if (
                response.data.tax &&
                response.data.is_vat_zero_to_all_products === "0"
              ) {
                this.form.vatPercent = response.data.tax;
              } else {
                this.idVatReadonly = true;
                this.form.vatPercent = 0;
              }

              if(response.producer_data){
                this.brand_name = response.producer_data.brand_name;
                this.getSlug(1,this.brand_name)
                // console.log('brnad-name', response.producer_data.brand_name)
              }
          } 
        })
        .catch((err) => {
          this.btnDisable = false;
          this.submitText = "Abschicken";
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 5000,
          });
        });

        adminAPI
        .editProducer({ id: provider_id })
        .then((response) => {
          if (response.status == "success") {
              if (response.data.producer_detail.categories.length) {
                  response.data.producer_detail.categories.forEach((item) => {
                    if (item.category_detail) {
                      this.categories.push({
                        category_name: item.category_detail.category_name,
                        id: item.category_id,
                      });
                    }
                  });
              }
        
            }
        })
        .catch((err) => {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },

    getProducers() {
      let data = {
        user_id: this.currentUser.id,
        page: 1,
        per_page: 20,
        search_company_field: '',
        search_email_field: '',
        search_phone_field: '',
        sort_column: 'id',
        sort_type: 'desc',
        is_admin_dealer:this.is_admin_dealer
      };
      adminAPI
        .getProducers(data)
        .then((response) => {
          if (response.status == "success") {
            this.providerID = response.data.length > 0 ? response.data[0].id : '';
            // this.providerID = '';
            if (this.providerID) {
              this.form.producer =  this.providerID;
              this.getGeneralSettings(this.providerID);
            } else {
              this.statusDelar = true;
              this.btnDisable = true;
              this.btnDraftDisable = true;
              return false;
            }
          } else {
            console.log("err")
          }
        })
        .catch((err) => {
         console.log(err)
        });
    },

    saveDraft() {
      if (!this.providerID) {
        this.statusDelar = true
        this.btnDisable = true;
        this.btnDraftDisable = true;
        return false;
      }
      if (this.form.productName) {
        this.btnDisable = true;
        this.btnDraftDisable = true;
        this.draftText = "Wird gespeichert...";
        this.submitStatus = "0";
        // this.form.productDescription = this.form.productDescription.split('<p></p>').join('');

        let formData = new FormData();
        formData.append("user_id", this.currentUser.id);
        formData.append("product_name", this.form.productName);
        formData.append("product_description", this.form.productDescription);
        formData.append("product_category", this.form.productCategory);
        formData.append("product_prices", this.form.productPrice);
        formData.append("is_admin_dealer", this.is_admin_dealer); 
        //formData.append("age_limit", this.form.ageLimit);
        let productAgeLimit = 0;
        if (this.form.ageLimit > 0) productAgeLimit = this.form.ageLimit;
        formData.append("age_limit", productAgeLimit);

        formData.append("badge_id", this.form.productBadge);
        formData.append("unit_id", this.form.productUnit);

        formData.append("product_status", this.submitStatus);
        let productVatPercent = 0;
        if (this.form.vatPercent > 0) productVatPercent = this.form.vatPercent;

        formData.append("product_vat", this.form.vatPercent);
        // BY DEFAULT SET CREDIT CARD OPTION
        formData.append("payment_option", 1);
        const features = [];
        for (var i = 0; i < this.form.productFeatures.length; i++) {
          features.push(this.form.productFeatures[i].id);
        }
        formData.append("product_features", JSON.stringify(features));
        // const delOptions = [];
        // for (var i = 0; i < this.form.deliveryOptions.length; i++) {
        //   delOptions.push(this.form.deliveryOptions[i].id);
        // }
        // formData.append("delvery_options", JSON.stringify(delOptions));

        if (this.form.productImages.length) {
          for (var i = 0; i < this.form.productImages.length; i++) {
            formData.append("file[" + i + "]", this.form.productImages[i]);
          }
        }
        formData.append(
          "product_informations",
          JSON.stringify(this.form.productInformations)
        );
        formData.append(
          "product_prices",
          JSON.stringify(this.form.productPrices)
        );        setTimeout(() => {
          axios
            .request({
              method: "POST",
              url: "/add-product",
              mimeType: "multipart/form-data",
              data: formData,
            })
            .then((response) => {
              if (response.data.status == "success") {
                this.btnDisable = false;
                this.btnDraftDisable = false;
                this.draftText = "Entwurf speichern";
                this.$notify({
                  group: "products",
                  type: "success",
                  position: "bottom right",
                  text: response.data.msg,
                  duration: 5000,
                });
                setTimeout(() => {
                  this.$router.push({ name: "products" });
                }, 2000);
              } else {
                this.btnDisable = false;
                this.btnDraftDisable = false;
                this.draftText = "Entwurf speichern";
                this.$notify({
                  group: "products",
                  type: "error",
                  position: "bottom right",
                  text: response.data.msg,
                  duration: 5000,
                });
              }
            })
            .catch((err) => {
              this.btnDisable = false;
              this.btnDraftDisable = false;
              this.draftText = "Entwurf speichern";
              this.$notify({
                group: "products",
                type: "error",
                position: "bottom right",
                text: err,
                duration: 5000,
              });
            });
        }, 2000);
      } else {
        this.$notify({
          group: "products",
          type: "error",
          position: "bottom right",
          text: "Bitte geben Sie den Namen der Unterkunft ein, um ihn als Entwurf zu speichern.",
          duration: 5000,
        });
      }
    },

    onSubmit() {
      if (!this.providerID) {
        this.statusDelar = true
        this.btnDisable = true;
        this.btnDraftDisable = true;
        return false;
      }
      this.$refs.newProductForm.validate().then((success) => {
        if (success && this.form.file !== null) {
          this.btnDisable = true;
          this.btnDraftDisable = true;
          this.submitText = "Wird abgeschickt...";
          this.submitStatus = "2";
          // this.form.productDescription = this.form.productDescription.split('<p></p>').join('');

          let formData = new FormData();
          formData.append("user_id", this.currentUser.id);
          formData.append("product_name", this.form.productName);
          formData.append("product_description", this.form.productDescription);
          formData.append("product_category", this.form.productCategory);
          formData.append("product_prices", this.form.productPrice);
          formData.append("meta_description", this.form.productMetaDescription);
          formData.append("title", this.form.productMetaTitle);
          formData.append("canonical_link", this.form.productCanonicalLink);
          formData.append("meta_robots", this.form.productMetaRobot ?? ""); 
          formData.append("is_admin_dealer", this.is_admin_dealer); 
          let productVatPercent = 0;
          if (this.form.vatPercent > 0) productVatPercent = this.form.vatPercent;

          formData.append("product_vat", this.form.vatPercent);         
          //formData.append("age_limit", this.form.ageLimit);
          let productAgeLimit = 0;
          if (this.form.ageLimit > 0) productAgeLimit = this.form.ageLimit;

          formData.append("age_limit", productAgeLimit);
          formData.append("badge_id", this.form.productBadge);
          formData.append("unit_id", this.form.productUnit);

          formData.append("producer_id", this.form.producer);
          formData.append("product_status", this.submitStatus);
          //formData.append("payment_option", this.form.productPayOption);
          // BY DEFAULT SET CREDIT CARD OPTION
          formData.append("payment_option", 1);
          const features = [];
          for (var i = 0; i < this.form.productFeatures.length; i++) {
            features.push(this.form.productFeatures[i].id);
          }
          formData.append("product_features", JSON.stringify(features));

          // const certificates = [];
          // for (var i = 0; i < this.form.productCertificates.length; i++) {
          //   certificates.push(this.form.productCertificates[i].id);
          // }
          // formData.append("product_certificates", JSON.stringify(certificates));

          // const delOptions = [];
          // for (var i = 0; i < this.form.deliveryOptions.length; i++) {
          //   delOptions.push(this.form.deliveryOptions[i].id);
          // }
          // formData.append("delvery_options", JSON.stringify(delOptions));
          //formData.append("file", this.form.file);
          if (this.form.productImages.length) {
            for (var i = 0; i < this.form.productImages.length; i++) {
              formData.append("file[" + i + "]", this.form.productImages[i]);
            }
          }
          formData.append(
            "product_informations",
            JSON.stringify(this.form.productInformations)
          );

          // formData.append(
          //   "state_informations",
          //   JSON.stringify(this.form.stateInformations)
          // );
          formData.append(
            "product_prices",
            JSON.stringify(this.form.productPrices)
          );
    
          setTimeout(() => {
            axios
              .request({
                method: "POST",
                url: "/add-product",
                mimeType: "multipart/form-data",
                data: formData,
              })
              .then((response) => {
                if (response.data.status == "success") {
                  this.btnDisable = false;
                  this.btnDraftDisable = false;
                  this.submitText = "Abschicken";
                  this.$notify({
                    group: "products",
                    type: "success",
                    position: "bottom right",
                    text: response.data.msg,
                    duration: 5000,
                  });
                  setTimeout(() => {
                    this.$router.push({ name: "products" });
                  }, 2000);
                } else {
                  this.btnDisable = false;
                  this.btnDraftDisable = false;
                  this.submitText = "Abschicken";
                  this.$notify({
                    group: "products",
                    type: "error",
                    position: "bottom right",
                    text: response.data.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.btnDraftDisable = false;
                this.submitText = "Abschicken";
                this.$notify({
                  group: "products",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.$notify({
            group: "products",
            type: "error",
            position: "bottom right",
            text: 'fehlender obligatorischer Wert oder falsches Format',
            duration: 5000,
          });
          this.btnDisable = false;
          this.btnDraftDisable = false;
        }
      });
    },

    getSlug(id, name) {
      if (name && id){
        adminAPI
        .createSlug({ name: name })
        .then((response) => {
          if (response.status == "success") {
              console.log('createSlug', response)
              if ( id == 1){
                var b_slug = response.data.slug
                this.brand_name_slug = b_slug.substr(0, 15)
              } else {
                this.product_name_slug = response.data.slug
                this.form.productMetaTitle = name.substr(0, 50)
              }

              if(this.product_name_slug && this.brand_name_slug) {
                if (window.location.hostname == 'stage.marktplatzgenius.lcmx.at' || window.location.hostname == 'localhost') {
                  this.form.productCanonicalLink = 'https://stage.marktplatzgenius.lcmx.at/produkt/'+this.product_name_slug+'_' + this.brand_name_slug
                } else {
                  this.form.productCanonicalLink = 'https://marktplatzgenius.lcmx.at/produkt/'+this.product_name_slug+'_' + this.brand_name_slug
                }
              }
          } 
        }).catch((err) => {
            console.log(err)
        });
      }
    },
    getEditorData(htmlData) {
      // console.log('fffffffff', htmlData)
      // 
      const tempElement = document.createElement('div');
      tempElement.innerHTML = htmlData;
      const plainText = tempElement.textContent;
      var removeEnter = plainText.replace(/\r?\n|\r/g, '');
      this.form.productMetaDescription = removeEnter.substr(0,160);
      // console.log(plainText);
    },
    restorePopUp(e){
      if((e=='1') && (!this.form.productMetaDescription)&& (this.form.productDescription)){
        this.restoreField = e;
        this.statusDialog = true;
      }else if((e=='2') && (!this.form.productMetaTitle) && (this.form.productName)){
        this.restoreField = e;
        this.statusDialog = true;
      }else if((e=='3') && (!this.form.productCanonicalLink) && (this.brand_name) && (this.form.productName)){
        this.restoreField = e;
        this.statusDialog = true;
      }
      
    },
    hideModal(){
      this.statusDelar = false
      this.statusDialog = false
    },
    async restore(){
      if(this.restoreField == '1') {
        this.getEditorData(this.form.productDescription)
      }else if(this.restoreField == '2') {
        this.form.productMetaTitle = this.form.productName.substring(0,50);
      }else if(this.restoreField == '3') {
       await this.getSlug(1,this.brand_name);
       await this.getSlug(2, this.form.productName);
      }
      this.statusDialog = false
    }
  },
  computed: {
    ...mapGetters(["isAuthenticated", "currentUser"]),
    isDisabled: function () {
      return this.btnDisable;
    },
    isDraftDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.draft-button {
  background-color: #ff9419 !important;
}

.draft-button:hover {
  background-color: #e57a00 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.mx-datepicker {
  width: 100% !important;
}
</style>
